import { actionCreatorFactory } from "typescript-fsa";

const actionFactory = actionCreatorFactory("MODULF");

export const LOAD_CONTACT_DATA = actionFactory<{ appKeys: string[]; activityId: string }>("LOAD_CONTACT_DATA");

export const SET_CONTACT_DATA = actionFactory<{ activityId: string }>("SET_CONTACT_DATA");
